import type { DocumentSendRow } from './types';

/** Integer cents; an explicit zero win takes precedence over the quote range. */
export function wonProjectValue(send: Pick<DocumentSendRow, 'won_amount_cents' | 'amount_min_cents' | 'amount_max_cents'>): number | null {
  if (send.won_amount_cents !== null) return send.won_amount_cents;
  const low = send.amount_min_cents, high = send.amount_max_cents;
  if (low !== null && high !== null) return low + Math.round((high - low) / 2);
  return low ?? high;
}
export function validDeposit(value: unknown): value is number | null {
  return value === null || (typeof value === 'number' && Number.isSafeInteger(value) && value > 0 && value <= 10_000_000);
}
